var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pb-5" }, [
    _vm.profile
      ? _c(
          "div",
          { staticClass: "container container-small" },
          [
            _c("Heading", {
              staticClass: "py-4",
              attrs: { title: _vm.$t("edit_profile_title") },
            }),
            _c("BillingProfile", {
              attrs: { mode: "edit", errorMsgs: _vm.errorMsgs },
              on: {
                input: function ($event) {
                  return _vm.updateProfileFromComponent($event)
                },
                resetErrors: _vm.resetErrorMsgs,
              },
              model: {
                value: _vm.profile,
                callback: function ($$v) {
                  _vm.profile = $$v
                },
                expression: "profile",
              },
            }),
            _c("div", { staticClass: "text-center pt-4 pb-4" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-purple w-100",
                  on: {
                    click: function ($event) {
                      return _vm.updateProfile()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("btn_save")))]
              ),
            ]),
            _c("div", { staticClass: "pb-4 text-right" }, [
              _c(
                "a",
                {
                  staticClass: "text-danger pointer",
                  on: {
                    click: function ($event) {
                      return _vm.remove(_vm.profile.id)
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-trash my-auto",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" " + _vm._s(_vm.$t("profiles_delete_profile"))),
                ]
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }